import styled from 'styled-components';

import DefaultProfile from '../../../media/img/defaultProfile.png';

const Container = styled.div`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
`;

const Img = styled.img`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
`;

type Props = {
  size: number;
  profileImage?: string | null;
};

const ProfileImage = ({ size, profileImage }: Props) => (
  <Container size={size}>
    <Img size={size} src={profileImage || DefaultProfile} />
  </Container>
);

export default ProfileImage;
